<script>
import mapboxgl from "mapbox-gl";

export default {
  name: "MglFullscreenControl",
  inject: ["map", "mapComponent"],
  props: {
    position: {
      type: String,
      default: "top-right",
    },
  },
  render: (h) => h(),
  data() {
    return {
      control: null,
    };
  },
  mounted() {
    this.$nextTick(() => {
      if (!this.map) return;
      this.control = new mapboxgl.FullscreenControl({
        container: this.mapComponent.$el,
      });
      this.map.addControl(this.control, this.position);
    });
  },
  beforeDestroy() {
    if (this.map && this.control) {
      this.map.removeControl(this.control);
    }
  },
};
</script>
